<template>
  <div class="agent-my-code">
    <div class="container">
      <h3>我的推广码</h3>
      <div class="code-container">
        <div class="loading-container" v-if="loading">
          <el-button type="text" icon="el-icon-loading" />
        </div>
        <div ref="qrcode"></div>
        <div class="empty" v-if="!linkData.link && !loading">暂无推广码</div>
      </div>
      <div class="qrcode-des" v-if="linkData.startTime">
        {{ linkData.startTime }} 到 {{ linkData.endTime }}
      </div>
      <div class="qrcode-des">{{ linkData.uniCode }}</div>
      <el-button
        type="primary"
        class="down-btn"
        icon="el-icon-refresh"
        @click="refreshQrCode"
        v-if="!loading"
        >点击刷新</el-button
      >
      <!--<el-button type="primary" class="down-btn" icon="el-icon-download" @click="downloadQrCode" v-if="codeLink && !loading">点击保存</el-button>-->
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { getAgentLink, refreshLink } from "api/request";
export default {
  name: "myAgentCode",
  data() {
    return {
      //codeLink: undefined,
      loading: false,
      linkData: [],
    };
  },
  mounted() {
    this.getAgentLink();
  },
  methods: {
    async getAgentLink() {
      this.loading = true;
      //this.linkData.link = undefined
      this.$refs.qrcode.innerHTML = "";
      try {
        const result = await getAgentLink();
        this.loading = false;
        this.linkData = result;
        //this.linkData.link = result ? result.link : undefined
        if (this.linkData.link) {
          this.creatCode(this.linkData.link);
        }
      } catch (e) {
        this.loading = false;
      }
    },
    creatCode(link) {
      this.$nextTick(() => {
        this.$refs.qrcode.innerHTML = "";
        const qrcodeEl = this.$refs.qrcode;
        let qrcode = new QRCode(qrcodeEl, {
          // 第一个参数是组件的id值
          text: link, // 生成二维码的文本
          width: 280,
          height: 280,
          colorDark: "#000000", // 二维码色
          colorLight: "#ffffff", // 二维码背景色
          correctLevel: QRCode.CorrectLevel.H, // 容错等级
        });
      });
    },
    downloadQrCode() {
      var canvasData = this.$refs.qrcode.getElementsByTagName("canvas");
      var a = document.createElement("a");
      var event = new MouseEvent("click"); // 创建一个单击事件
      a.href = canvasData[0].toDataURL("image/png")
      a.download = "我的推广码"
      a.dispatchEvent(event) // 触发a的单击事件
    },
    /** 刷新code */
    async refreshQrCode() {
      this.getAgentLink()
      // const result = await refreshLink()
      // if (result && result.link) {
      //   this.linkData = {}
      //   const { link } = result
      //   this.linkData = result
      //   this.creatCode(link)
      // }
    }
  },
};
</script>

<style scoped lang="scss">
.agent-my-code {
  width: 100%;
  height: 100%;
  .container {
    text-align: center;
  }
  .code-container {
    width: 300px;
    height: 300px;
    text-align: center;
    margin: 0 auto;
    padding: 10px;
    border: 3px solid #f5f5f5;
    position: relative;
  }
  .loading-container {
    width: 300px;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    background-color: rgba(0,0,0, .6);
    /deep/.el-button {
      cursor: default;
      .el-icon-loading {
        font-size: 30px;
      }
    }
  }
  .empty {
    width: 300px;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #999;
  }
  .down-btn {
    width: 326px;
    margin: 10px auto;
  }
  .qrcode-des{
    font-weight: bolder;
    color: red;
    margin-top: 10px;
  }
}
</style>
